# GitHub Action — drift on every PR

The `cairntools/cairn-action` composite action runs `cairn scan` against your PR head and posts a single update-in-place comment summarizing drift grouped by flow.

## Install

Add `.github/workflows/cairn.yml` to your repo:

```yaml
name: Cairn drift scan
on:
  pull_request:
    branches: [main]

jobs:
  scan:
    runs-on: ubuntu-latest
    permissions:
      contents: read
      pull-requests: write
    steps:
      - uses: actions/checkout@v4
      - uses: cairntools/cairn-action@v1
        with:
          graphs-path: .graphs
```

The first PR after install creates a fresh sticky comment. Subsequent PRs update the same comment in place — no comment spam.

## CI policy

Add `ci.driftPolicy` to `.graphs/.config.yaml` to control whether the Action blocks merge:

```yaml
ci:
  driftPolicy: warn          # default — render the comment, exit 0
  # driftPolicy: block_on_high   # exit 1 if any drift confidence >= 0.9
  # driftPolicy: block_any        # exit 1 on any drift
```

`block_on_high` is the common choice once you trust your fingerprints — it lets text-content drift through (which is usually intentional copy edits) while catching selector renames and element-removal cases that almost certainly need a graph patch.

## What the comment looks like

When drift exists, the comment shows total count + high-confidence breakdown, then one collapsible section per flow with a table:

| Confidence | Kind | Node | Signals matched |
|---|---|---|---|
| :green_circle: 95% | `selector_renamed` | `signin` | testId, role |
| :yellow_circle: 55% | `element_removed` | `dashboard` | role |

Per-row guidance: run `cairn accept` locally to apply high-confidence patches; dismiss the rest in the dashboard.

## Authentication

V1 runs `cairn scan` locally inside the Action — no Cairn API token required. The `cairn-token` input is reserved for V1.5 (hosted-scan posting straight from the dashboard via the Action's API).

The Action uses the workflow's default `GITHUB_TOKEN` for the comment post, which is already scoped to `pull-requests: write`.

## Source

The action lives in this repo at [`.github/actions/cairn-scan/`](https://github.com/cairntools/cairn/tree/main/.github/actions/cairn-scan). V1.5 mirrors it to a dedicated release repo at `cairntools/cairn-action` for stable `@v1` tags.
